<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-12">
                <div class="service">
                    <h2 class="text-center">
                        {{"Website design tutorials" | translate}}
                    </h2>
                </div>
            </div>
            <div class="col-md-12 text-center">
                <img src="./../../../assets/images/train.png" alt="seo" />
            </div>
        </div>
    </div>
</section>

<section class="intro-section" style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(./../../../../assets/images/bg3.jpg);">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="w-100 content">
                <p>
                    {{"Code Roots Company seeks to help our clients reach the highest level in web design, corporate management programs, and e-marketing. Therefore, we offer you some simple lessons in each of these areas" | translate}}
                </p>
            </div>
        </div>
    </div>
</section>